
  import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
  import CardContainer from "@/components/card/CardContainer.vue";
  import DefaultProjectImage from "@/components/card/DefaultProjectImageNewDashBoard.vue";
  import CardTitleContainer from "@/components/card/CardTitleContainer.vue";
  import RouteParams from "@/entities/RouteParams";
  import { Project, User } from "@/generated/graphql";
  import RouteNames from "@/entities/RouteNames";
  import CardSection from "@/components/card/CardSection.vue";
  import CardItemBaseContainer from "@/components/card/CardItemBaseContainer.vue";
  import getFullNameOrPlaceholder from "@/helpers/getFullNameOrPlaceholder";
  import ItemChipsData from "@/entities/ItemChipsData";
  import BudgetRange from "@/components/common/BudgetRange.vue";
  import { getCardDateFormat } from "@/helpers/date";
  import ShortenedText from "@/components/common/ShortenedText.vue";
  import CreateGroupConversation from "@/components/inbox/CreateGroupConversation.vue";
  import ProjectActivityAction from "@/components/projects/activities/ProjectActivityAction.vue";
  import ProjectAction from "@/components/projects/ProjectAction.vue";
  import ConversationUserDataForModal from "@/entities/ConversationUserDataForModal";
  import Roles from "@/entities/Roles";
  import getProjectActivitiesCount from "@/helpers/project/getProjectActivitiesCount";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import ProjectStatus from "@/components/projects/ProjectStatus.vue";
  //import ProjectDourghnutChart from '@/components/common/Charts/ProjectDourghnutChart.vue'

  @Component({
    components: {
      ProjectStatus,
      CardItemTitle,
      ProjectAction,
      ProjectActivityAction,
      CreateGroupConversation,
      ShortenedText,
      BudgetRange,
      CardItemBaseContainer,
      CardSection,
      CardTitleContainer,
      DefaultProjectImage,
      CardContainer,
      //ProjectDourghnutChart
    },
  })
  export default class ProjectCard extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly project!: Project;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly hideManager!: boolean;
    @Prop({ type: String, default: RouteNames.PROJECT_ACTIVITY }) readonly projectDetailsRoute!: RouteNames;
    @PropSync('descriptionBlockHeight', { type: Number, default: undefined }) descriptionBlockHeightValue?: number;

  RouteNames = RouteNames;

  get inProgress(): number {
    const current = new Date();
    return this.project.project_activities.filter(date => new Date(date.end_date) > current).length;
  }

  get isManagerShown(): boolean {
    if (this.hideManager) {
      return false;
    }

    return this.isAdmin;
  }

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get manager(): ItemChipsData | undefined {
    const manager = this.project.manager;

    if (!manager) {
      return;
    }

    const {
      id,
      given_name,
      family_name,
      avatar,
    } = manager.user;

    return {
      id,
      avatar: avatar || undefined,
      name: getFullNameOrPlaceholder(given_name, family_name),
      routeParams: {
        name: RouteNames.MANAGER_ABOUT,
        params: {
          id: manager.id
        },
      },
    };
  }

  get projectActivitiesPageRoute(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.PROJECT_ACTIVITY,
      params: {
        id: this.project.id
      },
    };
  }
  viewProject(project: Project): void {
    this.$router.push({
      name: this.projectDetailsRoute,
      params: {id: project.id}
    });
  } 
  editProject(project: Project): void {
    this.$emit("editProjects", project);
  } 
  get projectDetailsPageRoute(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.PROJECT_DETAILS,
      params: {
        id: this.project.id
      },
    };
  }

  get totalActivities(): string | undefined {
    return getProjectActivitiesCount(this.project);
  }

  get startDate(): string {
    return getCardDateFormat(this.project.created_at);
  }

  get endDate(): string {
    return getCardDateFormat(this.project.end_date);
  }
  get totalHours(): number {
    //@ts-ignore
    return Math.ceil(Math.abs(new Date(this.project.end_date) - new Date(this.project.created_at)) / 36e5);
  }
  get leftHours(): number{
    let date = new Date();
    //@ts-ignore
    return Math.ceil(Math.abs(new Date(this.project.end_date) - date) / 36e5);
  }
  get hasParticipants(): boolean {
    return this.projectUsers.length > 0;
  }

  get totalContractors(): string {
    return String(this.projectContractors.length);
  }


  get projectUsers(): ConversationUserDataForModal[] {
    const manager = this.project.manager?.user;

    if (!manager || this.currentUser.role === Roles.MANAGER) {
      return this.projectContractors;
    }

    return [
      ...this.projectContractors,
      {
        userId: manager.id,
        avatar: manager.avatar,
        name: `${manager.given_name} ${manager.family_name} (manager)`,
      }
    ]
  }

  get projectContractors(): ConversationUserDataForModal[] {
    const { project_activities: activities } = this.project;

    if (!activities.length) {
      return [];
    }

    const uniqueIds = new Set;

    return activities.reduce((arr: ConversationUserDataForModal[], { contractor }) => {
      const user = contractor?.user;
      if (!user) {
        return arr;
      }
      const currentStepContractors: ConversationUserDataForModal[] = [];

      if (!uniqueIds.has(user.id)) {
        currentStepContractors.push({
          userId: user.id,
          avatar: user.avatar,
          name: `${user.given_name} ${user.family_name}`,
        });
        uniqueIds.add(user.id)
      }

      return arr.concat(currentStepContractors);
    }, []);
  }
}
